import './Shell.css';
import Header from '@cimpress-technology/react-platform-header';
import { Snackbar } from '@cimpress/react-components';
import { AccountSelector } from '@cimpress-technology/pex-react-components';
import { hideSnackbar } from '../../redux/actions/snackbarActions';
import { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { getAccountDetails, setSelectedAccountId } from '../../redux/actions/accountDetailsActions';
import { READ_ACCOUNT } from '../../constants/common';
import CssLoader from '@cimpress/react-components/lib/CssLoader';
import { GlobalStyles } from '@cimpress/react-components_v16';
import auth from '../../services/auth';

function Shell({ children, delay, style, message, showSnackbar, selectedAccountId }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAccountDetails());
  }, [dispatch]);

  return (
    <CssLoader>
      <GlobalStyles />
      <Snackbar show={showSnackbar} status={style} delay={delay} onHideSnackbar={() => dispatch(hideSnackbar())}>
        {message}
      </Snackbar>
      <Header
        responsive
        accessToken={auth.getAccessToken()}
        title={'PIM'}
        titleUrl={'https://pim.cimpress.io'}
        appKey={'Production Delay'}
        profile={auth.getProfile()}
        onLogInClicked={() => auth.login()}
        onLogOutClicked={() => auth.logout('/')}
        isLoggedIn={auth.isLoggedIn()}
        accountSelector={
          <AccountSelector
            permissions={[READ_ACCOUNT]}
            authToken={auth.getAccessToken()}
            selectedAccountId={selectedAccountId}
            onChange={account => dispatch(setSelectedAccountId(account?.accountId))}
          />
        }
      />
      <div className='root-child'>{children}</div>
    </CssLoader>
  );
}

const mapStateToProps = ({ snackbar: { showSnackbar, delay, style, message }, accountDetails }) => ({
  showSnackbar,
  delay,
  style,
  message,
  selectedAccountId: accountDetails.selectedAccountId,
});
export default connect(mapStateToProps)(Shell);
